import React from 'react';
import { useAnalyticsCardBase } from '../../../../../hooks/useAnalyticsCardBase';
import { ConversionRateReportCardLabel } from './components/ConversionRateReportCardLabel';
import { calculatePercentage } from './utils/calculatePercentage';
const reportId = 'conversion_rates';
export const useConversionRateReportCard = () => {
    const analyticsCardBase = useAnalyticsCardBase({ reportId });
    const summaryData = analyticsCardBase.reportData?.report?.summary;
    const data = [
        {
            label: (React.createElement(ConversionRateReportCardLabel, { label: "Added to cart", sessionsNumber: summaryData?.cart_created_count || 0 })),
            value: calculatePercentage(summaryData?.cart_created_count || 0, summaryData?.total_sessions || 0),
        },
        {
            label: (React.createElement(ConversionRateReportCardLabel, { label: "Checkout started", sessionsNumber: summaryData?.checkout_created_count || 0 })),
            value: calculatePercentage(summaryData?.checkout_created_count || 0, summaryData?.total_sessions || 0),
        },
        {
            label: (React.createElement(ConversionRateReportCardLabel, { label: "Successful checkout", sessionsNumber: summaryData?.checkout_paid_count || 0 })),
            value: calculatePercentage(summaryData?.checkout_paid_count || 0, summaryData?.total_sessions || 0),
        },
    ];
    return {
        value: calculatePercentage(summaryData?.checkout_paid_count || 0, summaryData?.total_sessions || 0),
        ...analyticsCardBase,
        formatValue: (value) => `${value}%`,
        legend: undefined,
        type: 'stats',
        data,
    };
};
